import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';
import { wrapFetch } from '#/fetch-wrapper';


const getReportsVersion = async () => {

    const { data } = await api.get('/reports-version');

    return data;
};

export const useReportsVersion = (queryOptions = {}) => useQuery('reports-version-get', () => getReportsVersion(queryOptions));


const updateReportsVersion = payload => wrapFetch(() => api.put('/reports-version', payload));


export const useUpdateReportsVersion = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({
        payload
    }) => updateReportsVersion(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('reports-version-get');
        },
        ...queryOptions
    });
};
